import Vue from 'vue'
import Jsonp from 'vue-jsonp'
import OSS from 'ali-oss'
import { get, post } from './axios'
Vue.use(Jsonp)

//接口域名控制
const test = false

const prod = 'https://openapi.roewe.com.cn'
const dev = 'http://openapi.roewe.com.cn'
const dbenv = test && process.env.NODE_ENV === 'development'?dev:prod

//获取省份信息
const getProvince = () => {
    return Vue.jsonp(`${dbenv}/ndms-base-server/getArea/2/1000000000/1/1`)
}

//获取城市信息
const getCity = ( province ) => {
    return Vue.jsonp(`${dbenv}/ndms-base-server/getArea/3/${province}/1/1`)
}

//获取经销商信息
const getDistributor = ( city ) => {
    return Vue.jsonp(`${dbenv}/ndms-base-server/getAreaByType/1/${city}`)
}

//获取手机验证码
const getCallMsg = test && process.env.NODE_ENV === 'development'?post(`https://mp-qa.ebanma.com:20016/app-mp/uais/1.0/verifyCode2MobileWithRoewe`):
post(`https://mp.ebanma.com/app-mp/uais/1.0/verifyCode2MobileWithRoewe`)

//获取oss临时token
const getOSSToken = test && process.env.NODE_ENV === 'development'?get(`https://mp-qa.ebanma.com:20016/app-mp/saicbsc/1.0/getOssToken`):
get(`https://mp.ebanma.com/app-mp/saicbsc/1.0/getOssToken`)

//表单提交
const submitForm = test && process.env.NODE_ENV === 'development'?post(`https://mp-qa.ebanma.com:20016/app-mp/saicbsc/1.0/BscOrderCreate`):
post(`https://mp.ebanma.com/app-mp/saicbsc/1.0/BscOrderCreate`)

//oss上传封装
const ossUpload = (params)=>{
    const ossStore = new OSS(params)
    return function (objkey, files) {
      return ossStore.put(objkey, files).then((res)=> {
      	ossStore.putACL(objkey,'private')
      	return res
      })
    }
}



export {
    getProvince,
    getCity,
    getDistributor,
    getCallMsg,
    getOSSToken,
    ossUpload,
    submitForm
}
